import script from "./SecuritySettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SecuritySettings.vue?vue&type=script&setup=true&lang=js"

import "./SecuritySettings.vue?vue&type=style&index=0&id=7af86c54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af86c54"]])

export default __exports__